import {applyMiddleware, compose, createStore} from 'redux';
import RootReducer from '../reducers'

import thunk from 'redux-thunk';
const level = 'error';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(
    RootReducer,
    composeEnhancers(
        applyMiddleware(
            thunk
        )
    )
);

export default store
